<div class="thumb-preview-problem" [attr.data-start-pos-x]="startPosX" [attr.data-is-premium-member-only]="isPremiumMemberOnly">
  <img
    loading="lazy"
    [ngStyle]="{ 'width.%': 100 / imageRatio }"
    [src]="imageSrc"
    (error)="onImageError()"
    alt=""
    *ngIf="baseSizeDir === 'width'"
  />
  <img
    loading="lazy"
    [ngStyle]="{ 'height.%': 100 / imageRatio }"
    [src]="imageSrc"
    (error)="onImageError()"
    alt=""
    *ngIf="baseSizeDir === 'height'"
  />
</div>
